const fontSize = {
  xxxLarge: 24,
  xxLarge: 22,
  xLarge: 20,
  large: 17,
  middle: 14,
  small: 12,
}

export { fontSize }